import React, { ReactNode } from 'react'
import { Project, StatusTypes } from 'models'
import { Text1 } from 'components/shared'
import styles from './ProjectsTableLine.module.scss'

export const getStatusesForProject = (prj: Project): StatusTypes[] => {
  let statuses: StatusTypes[] = []
  if (!prj.children || prj.children.length === 0) {
    statuses.push(prj.status)
  } else {
    prj.children.forEach(p => {
      statuses = statuses.concat(getStatusesForProject(p))
    })
  }
  return statuses
}

export const renderProjectStatusComponent = (project: Project): ReactNode => {
  let text: string
  let color: string

  if (project.children && project.children.length) {
    const statuses = getStatusesForProject(project)
    const totalNumberOfVideos = statuses.length
    const numberOfPublishedVideos = statuses.reduce((sum, status) => {
      return status === StatusTypes.PUBLISHED ? sum + 1 : sum
    }, 0)

    text = `${totalNumberOfVideos} video${totalNumberOfVideos === 1 ? '' : 's'}, ${numberOfPublishedVideos} published`
  } else {
    switch (project.status) {
      case StatusTypes.HAS_CHANGES: {
        text = 'Has changed'
        color = styles.error
        break
      }
      case StatusTypes.NEW: {
        text = 'New'
        color = styles.primary
        break
      }
      case StatusTypes.PUBLISHED: {
        text = 'Published'
        color = styles.secondary
        break
      }
      case StatusTypes.NOT_PUBLISHED: {
        text = 'Not published'
        color = styles.secondary
        break
      }
      default: break
    }
  }

  return (
    <Text1 style={{ color }}>
      {text}
    </Text1>
  )
}
